import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismBanner } from '@mylighthouse/prism-ember';

interface HotelBenchmarkInsightBannersBannerTrialSignature {
  Args: {
    closeBanner: () => void;
  };
}

export default class HotelBenchmarkInsightBannersBannerTrial extends Component<HotelBenchmarkInsightBannersBannerTrialSignature> {
  @service declare access: Services['access'];
  @service('benchmark-insight/trial')
  declare benchmarkInsightTrial: Services['benchmark-insight/trial'];
  @service declare intl: Services['intl'];

  get bannerMessage(): string {
    if (this.benchmarkInsightTrial.hasRequestedTrial) {
      return this.intl.t(
        'benchmark_insight.light.banner_trial.message.requested',
      );
    }

    if (this.access.hasBenchmarkInsightTrialUpsellEdit) {
      return this.intl.t('benchmark_insight.light.banner_trial.message', {
        htmlSafe: true,
      });
    }

    return this.intl.t('benchmark_insight.light.banner_trial.message.viewer', {
      htmlSafe: true,
    });
  }

  get bannerTitle(): string {
    if (this.benchmarkInsightTrial.hasRequestedTrial) {
      return this.intl.t(
        'benchmark_insight.light.banner_trial.title.requested',
      );
    }

    return this.intl.t('benchmark_insight.light.banner_trial.title');
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get primaryAction() {
    if (
      this.access.hasBenchmarkInsightTrialUpsellEdit &&
      !this.benchmarkInsightTrial.hasRequestedTrial
    ) {
      return {
        label: this.intl.t('benchmark_insight.light.get_in_touch'),
        disabled: this.benchmarkInsightTrial.saveBeniUpsellRecordTask.isRunning,
        isLoading:
          this.benchmarkInsightTrial.saveBeniUpsellRecordTask.isRunning,
        iconAfter: 'arrow-right' as const,
        // eslint-disable-next-line @typescript-eslint/unbound-method
        action: this.benchmarkInsightTrial.onClickStartTrial,
      };
    }

    return {
      label: this.intl.t('benchmark_insight.upsell.banner.button.learn_more'),
      // eslint-disable-next-line @typescript-eslint/unbound-method
      action: this.benchmarkInsightTrial.openHelpArticle,
    };
  }

  <template>
    <PrismBanner
      @bannerMessage={{this.bannerMessage}}
      @bannerStyle="brand"
      @bannerTitle={{this.bannerTitle}}
      @close={{@closeBanner}}
      @hasCta={{true}}
      @icon="rocket"
      @primaryAction={{this.primaryAction}}
      data-test-id="banner-trial"
    />
  </template>
}
